import { Role } from '@/types/user.types';

export function isAdminRole(role: Role | undefined) {
  if (!role) {
    return false;
  }
  return role === Role.ADMIN || role === Role.SUPER_ADMIN;
}

export function isSuperAdminRole(role: Role | undefined) {
  if (!role) {
    return false;
  }
  return role === Role.SUPER_ADMIN;
}

export function isStaffRole(role: Role | undefined) {
  if (!role) {
    return false;
  }
  return role === Role.STAFF;
}
